import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import styles from './gokada.module.css';
import Slide from '../slide';

const Routes = require('../../routes').Routes;

function Gokada() {
  const data = useStaticQuery(
    graphql`
      query {
        background: file(relativePath: { eq: "bg/bg_gokada.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        image: file(relativePath: { eq: "bg_img_gokada.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundImageData = data.background.childImageSharp.fluid;
  const imageData = data.image.childImageSharp.fluid;

  return (
    <Slide
      contentClassName={styles.content}
      title="Gokada motorbike hailing service"
      text='"We helped our client develop a Gokada solution for his ride-sharing services and empowered it with a geo-location routing, a web-based admin panel and a cashless settlement system."'
      author={
        <React.Fragment>
          <span>
            <b>Rodion Salnik</b>,
          </span>{' '}
          <span>CEO & Co-Founder at Brocoders</span>
        </React.Fragment>
      }
      caseLink={Routes.CASE_STUDIES_GOKADA}
      backgroundImageData={backgroundImageData}
      imageData={imageData}
      bgColor="#019570"
      imageClassName={styles.image}
    />
  );
}

export default Gokada;
